import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ArrayMinSize, IsArray, IsNotEmpty, IsOptional, IsString, IsUUID, Length } from 'class-validator'

export class TableCombinationResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: String, isArray: true, format: 'uuid' })
	tableIds: string[]
}

export class CreateTableCombinationRequest {
	@ApiPropertyOptional({ type: String, format: 'uuid' })
	@IsOptional()
	@IsUUID()
	id?: string

	@ApiProperty({ type: String, minLength: 2, maxLength: 30 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 30)
	name: string

	@ApiProperty({ type: String, isArray: true, format: 'uuid', minItems: 2 })
	@IsNotEmpty()
	@IsArray()
	@ArrayMinSize(2)
	tableIds: string[]
}
